import * as React from 'react'
import { Redirect as ReactRouterRedirect, Route } from 'react-router-dom'

export default function Redirect(props) {
  const { from, to, exact, ...rest } = props

  if (!from) {
    return <ReactRouterRedirect {...props} />
  }

  return (
    <Route
      path={from}
      exact={exact || false}
      render={({ match }) => {
        const paramKeys = Object.keys(match.params)

        const toWithReplacedParamsKeys = paramKeys.reduce((url, key) => url.replace(`:${key}`, match.params[key]), to)

        return <ReactRouterRedirect to={toWithReplacedParamsKeys} {...rest} />
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Redirect.tsx